import React, { useRef } from 'react'
import "./index.css"
import Video from '../video/video';
import Audio from '../audio/audio';


const Outro = (props) => {
    const actorName = "JOE";
    const actorTitle = "Security Guard";
    const playVideo = useRef(null);
    const playAudio = useRef(null);

    const updateVideoStatue = (value) => {
      
        if (value === "ended") {
            props.goToStep(null, "FINALSCENE");
        }

    }
    const updateAudioStatue = (value) => {
       
    }

    return (
        <>
            <div className="Outro">
                <Video VideoURL="./videos/8_1_Outro.mp4" actorName={actorName} actorTitle={actorTitle} updateVideoStatue={updateVideoStatue} playVideo={playVideo} />
            </div>
            <Audio AudioURL="./musics/the-crackdown.mp3" autoPlay loop updateAudioStatue={updateAudioStatue} playAudio={playAudio} />

        </>
    );
}

export default Outro;